import { customFieldTypes, type CustomFieldType } from '@cod/config-schema';
import { Box, Button, Modal, Text, Title } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { customFieldTypeDescription, customFieldTypeName } from './fieldTypeNames.js';

/**
 * "Add custom field, button or image" modal. Lists the available element types; clicking Add
 * appends one to the fields list (handled by the caller) and closes the modal.
 */
export function AddFieldModal({
  open,
  onAdd,
  onClose,
}: {
  open: boolean;
  onAdd: (type: CustomFieldType) => void;
  onClose: () => void;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <Modal open={open} onDismiss={onClose}>
      <Modal.Header title={t('designer.addField.modalTitle')} />
      <Modal.Body padding="none">
        <Box display="flex" flexDirection="column" gap="2" paddingX="4" paddingBottom="4">
          {customFieldTypes.map((type) => {
            return (
              <Box
                key={type}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                gap="4"
                padding="3"
                borderColor="neutral-surfaceHighlight"
                borderStyle="solid"
                borderWidth="1"
                borderRadius="2"
              >
                <Box display="flex" flexDirection="column" gap="1">
                  {/* Same name the field's card will carry once it is added — one source, so the
                      list a merchant picks from and the card they get cannot disagree. */}
                  <Title as="h6">{customFieldTypeName(type, t)}</Title>
                  <Text fontSize="caption" color="neutral-textLow">
                    {customFieldTypeDescription(type, t)}
                  </Text>
                </Box>
                <Button onClick={() => onAdd(type)}>{t('designer.addField.add')}</Button>
              </Box>
            );
          })}
        </Box>
      </Modal.Body>
    </Modal>
  );
}
